/* eslint-disable func-style */
import _ from 'lodash';

/**
 * Appends a query parameter to a url.
 * Handles hashes and existing query strings.
 * When value is null or undefined, returns the original url.
 * @curried
 * @param {string} key - Key of query param to be appended
 * @param {string} value - Value of query param to be appended
 * @param {string} url - Url to append query parameter to
 * @returns {string} Url with query param appended
 * @type {(key: string, value: string, url: string) => string}
 */
export const appendQueryParam = _.curry((key, value, url) => {
  if (value === null || value === undefined) return url;
  const [withoutHash, hash] = url.split('#');
  const formattedHash = hash ? `#${hash}` : '';
  const separator = withoutHash.includes('?') ? '&' : '?';
  const param = `${key}=${value}`;
  return withoutHash + separator + param + formattedHash;
});
